import React, { useEffect } from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import { CheckCircleOutline as SuccessIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Optionally verify with backend or just show success
  }, []);

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: 6, textAlign: 'center', borderRadius: 4, border: '1px solid', borderColor: 'divider' }}>
        <SuccessIcon color="success" sx={{ fontSize: 80, mb: 4 }} />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 800 }}>
          Subscription Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Thank you for upgrading to InovDev Pro. Your account has been upgraded to Admin, and you now have full access to all features.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/projects')} size="large" sx={{ px: 4, borderRadius: 2 }}>
          Go to Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default SubscriptionSuccessPage;